<template>
  <div class="customerOrderDetailPage">
    <el-tabs v-model="activeName" type="border-card">
      <el-tab-pane
        :label="$l('INDEX.order_tab_base_information') || '基本信息'"
        name="base"
      >
        <OrderInfo ref="base" :orderCode="orderCode" />
      </el-tab-pane>
      <el-tab-pane
        :label="$l('INDEX.order_tab_order_goods') || '产品信息'"
        name="goods"
        lazy
      >
        <OrderGoods :orderCode="orderCode" />
      </el-tab-pane>
      <el-tab-pane
        :label="$l('INDEX.order_tab_demand_fabric') || '产品面料'"
        name="demandFabric"
        lazy
      >
        <DemandFabric :orderCode="orderCode" />
      </el-tab-pane>
      <el-tab-pane
        :label="$l('INDEX.order_tab_tech_doc') || '工艺说明'"
        name="techDoc"
        lazy
      >
        <TechDoc :orderCode="orderCode" />
      </el-tab-pane>
      <el-tab-pane
        :label="$l('INDEX.tab_doc') || '订单文件'"
        name="orderDoc"
        lazy
      >
        <OrderDoc :orderCode="orderCode" />
      </el-tab-pane>
      <el-tab-pane
        :label="$l('INDEX.order_tab_demand_material') || '产品辅料'"
        name="demandMabric"
        lazy
      >
        <DemandMaterial :orderCode="orderCode" />
      </el-tab-pane>
      <el-tab-pane
        :label="$l('INDEX.tab_goods_package_size') || '产品包装'"
        name="goodsPackageSize"
        lazy
      >
        <GoodsPackageSize :orderCode="orderCode" />
      </el-tab-pane>
      <el-tab-pane
        :label="$l('INDEX.order_tab_demand_package') || '外包装箱'"
        name="demandPackage"
        lazy
      >
        <DemandPackage :orderCode="orderCode" />
      </el-tab-pane>
      <el-tab-pane
        :label="$l('INDEX.tab_demand_packing') || '装箱方案'"
        name="demandPacking"
        lazy
      >
        <DemandPacking :orderCode="orderCode" />
      </el-tab-pane>
      <el-tab-pane
        :label="$l('INDEX.order_tab_sample_request') || '样品需求'"
        name="sampleRequest"
        lazy
      >
        <OrderGoodsProofing :orderCode="orderCode" />
      </el-tab-pane>
      <el-tab-pane
        :label="$l('INDEX.order_tab_delivery_batch') || '交货批次'"
        name="batch"
        lazy
      >
        <OrderBatch :orderCode="orderCode" />
      </el-tab-pane>
      <el-tab-pane
        :label="$l('INDEX.order_tab_inspection_requirements') || '验货要求'"
        name="checkRequest"
        lazy
      >
        <OrderInspection :orderCode="orderCode" />
      </el-tab-pane>
      <el-tab-pane
        :label="$l('INDEX.order_tab_execution_log') || '执行日志'"
        name="log"
        lazy
      >
        <OrderExecutionLog :orderCode="orderCode" />
      </el-tab-pane>
    </el-tabs>
  </div>
</template>
<script>
import OrderInfo from './components/info'
import OrderGoods from './components/goods'
import DemandFabric from './components/demand-fabric'
import DemandMaterial from './components/demand-material'
import DemandPackage from './components/demand-package'
import OrderGoodsProofing from './components/proofing'
import OrderBatch from './components/batch'
import OrderInspection from './components/inspection'
import OrderExecutionLog from './components/log'
import GoodsPackageSize from './components/goods-package-size/index.vue'
import DemandPacking from './components/demand-packing/index.vue'
import OrderDoc from './components/order-doc/index.vue'
import TechDoc from './components/tech-doc'

export default {
  components: {
    OrderInfo,
    OrderGoods,
    DemandFabric,
    DemandMaterial,
    DemandPackage,
    OrderGoodsProofing,
    OrderBatch,
    OrderInspection,
    OrderExecutionLog,
    GoodsPackageSize,
    DemandPacking,
    OrderDoc,
    TechDoc
  },
  props: {
    orderCode: String
  },
  data() {
    return {
      activeName: 'base'
    }
  },
  computed: {},
  methods: {}
}
</script>
